(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/bigstat-controller.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/bigstat-controller.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  SportTypes
} = svs.components.sport.sportTypes;
svs.game_results.BigStat = function () {
  const closeBigStat = domElement => {
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(document.querySelector(domElement));
    });
  };

  const openBigStat = opt => {
    var _svs$game_results;
    const coupon = document.querySelector('.game-results-coupon');
    svs.core.detect.formfactor.mobile() && coupon.classList.add('hide');
    const isSpecialTrotting = ((_svs$game_results = svs.game_results) === null || _svs$game_results === void 0 || (_svs$game_results = _svs$game_results.data) === null || _svs$game_results === void 0 || (_svs$game_results = _svs$game_results.config) === null || _svs$game_results === void 0 || (_svs$game_results = _svs$game_results.specialTrottingEvent) === null || _svs$game_results === void 0 ? void 0 : _svs$game_results.drawNumber) === opt.drawNumber;
    const searchParams = opt.searchParams && new URLSearchParams(opt.searchParams);
    const branding = svs.utils.products.getProductClassName(opt.productId);
    let matchId;
    if (opt.queryKey === 'match' && opt.queryValue) {
      matchId = parseInt(opt.queryValue, 10);
    } else {
      matchId = opt.matchId;
    }
    if (svs.core.detect.formfactor.mobile()) {
      matchId && svs.components.sportinfo.bigstat.renderBigStatModal(opt.domElement, {
        closeNavigationCallback: () => {
          Backbone.history.navigate("".concat(opt.modulePath.replace(/\/resultat/, '')), {
            replace: false
          });
          coupon.classList.remove('hide');
        },
        unmountBigStatCallback: () => closeBigStat(opt.domElement)
      }, {
        appendTabSearchParams: searchParams,
        branding,
        classNameWrapper: 'big-stat',
        modulePath: opt.modulePath,
        matchId,
        productId: opt.productId,
        drawNumber: opt.drawNumber,
        isWideDevice: svs.core.detect.formfactor.desktop(),
        theme: 'LIGHT',
        forceSportType: isSpecialTrotting ? SportTypes.Trotting : undefined
      });
    } else {
      svs.components.sportinfo.bigstat.renderBigStat(opt.domElement, {
        appendTabSearchParams: searchParams,
        branding,
        classNameWrapper: 'big-stat',
        modulePath: opt.modulePath,
        matchId,
        productId: opt.productId,
        drawNumber: opt.drawNumber,
        isWideDevice: svs.core.detect.formfactor.desktop(),
        theme: 'DARK',
        forceSportType: isSpecialTrotting ? SportTypes.Trotting : undefined
      });
    }
    const prevClickedElement = document.querySelector('.game-result-big-stat-expanded');
    if (prevClickedElement) {
      prevClickedElement.classList.remove('game-result-big-stat-expanded');
    }
    const clickedElement = document.getElementById("bigstatMatchId-".concat(opt.matchId));
    if (clickedElement) {
      clickedElement.classList.add('game-result-big-stat-expanded');
    }
  };

  const updateBigStatUrlQuery = opt => {
    const url = new URL(Backbone.history.location);
    const query = new URLSearchParams(url.search);
    if (opt.matchId && opt.matchId !== query.get('match')) {
      query.set('match', opt.matchId);
      url.search = query;
      if (svs.core.detect.formfactor.mobile()) {
        Backbone.history.navigate("".concat(url.pathname.replace(/\/resultat/, '')).concat(url.search), {
          replace: false
        });
      } else {
        Backbone.history.navigate("".concat(url.pathname.replace(/\/resultat/, '')).concat(url.search), {
          replace: true
        });
      }
    }
  };

  const navToBigStat = opt => {
    const url = new URL(window.location);
    const query = new URLSearchParams(url.search);
    if (query.has(opt.queryKey)) {
      const queryValue = query.get(opt.queryKey);
      const searchParams = "".concat(opt.queryKey, "=").concat(queryValue);
      setTimeout(() => {
        openBigStat(_objectSpread(_objectSpread({}, opt), {}, {
          queryValue,
          searchParams
        }));
      });
    }
  };
  return {
    closeBigStat,
    openBigStat,
    updateBigStatUrlQuery,
    navToBigStat
  };
};

 })(window);